<template>
  <div class='MarketingNave'>
    <div
    v-for="(l, key) in links"
    :key="key"
    :class="{ linkActive: l.to === $route.path, link: key !== 0, linkStart: true }"
    @click="$router.push(l.to)"
    >
      {{ l.name }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'MarketingNave',
  data () {
    return {
      links: [
        {
          name: 'Geral',
          to: '/painel/marketing'
        },
        {
          name: 'SEO',
          to: '/painel/marketing/seo'
        }
      ]
    }
  }
}
</script>

<style scoped>
.MarketingNave {
  display: flex;
  justify-content: start;
  padding: 1%;
}

.MarketingNave div {
  cursor: pointer;
}

.linkStart {
  color: #000000;
  padding: 1%;
}

.link {
  color: #000000;
  padding: 1%;
}

.linkActive {
  color: #FFFFFF;
  font-weight: bold;
  padding: 1%;
  background-color: #000000;
  border-radius: 5px;
}
</style>
